import { render, staticRenderFns } from "./AmountOfSalesCmp.vue?vue&type=template&id=8dc6de18&"
import script from "./AmountOfSalesCmp.vue?vue&type=script&lang=js&"
export * from "./AmountOfSalesCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports